var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SpecificationPanel',{attrs:{"label":_vm.label}},[(!_vm.editMode)?_c('span',{style:(Object.assign({}, { display: 'inline-block' }, _vm.textStyles))},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }